import { render, staticRenderFns } from "./NavigationMenuBranch.vue?vue&type=template&id=2f984647"
import script from "./NavigationMenuBranch.vue?vue&type=script&lang=js"
export * from "./NavigationMenuBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports